import { observer } from 'mobx-react-lite';
import {
  AttachmentParagraphT,
  DummyImageParagraphT,
  ImageParagraphT,
  PersonalMessageParagraphT,
  PostT,
  TextParagraphT,
  VideoParagraphT,
  YoutubeParagraphT,
} from 'types/shared/core/Post';
import PostContentText from './PostContentText';
import PostContentImage from './PostContentImage';
import { Stack, useTheme } from '@mui/material';
import PostContentAttachment from './PostContentAttachment';
import PostContentYoutube from './PostContentYoutube';
import PostContentPersonalMessage from './PostContentPersonalMessage';
import PostContentVideo from './PostContentVideo';
import PostContentDummyImage from './PostContentDummyImage';

type PostContentPropsT = {
  post: PostT;
  perspective: 'teacherSide' | 'studentSide';
  onPersonalMessageClick?: (paragraph: PersonalMessageParagraphT) => void;
};

const PostContent = observer(
  ({ post, onPersonalMessageClick }: PostContentPropsT) => {
    const { palette } = useTheme();
    return (
      <Stack spacing={2} pb={2} sx={{ background: palette.background.paper }}>
        {post.content.map((paragraph) =>
          paragraph.type === 'text' ? (
            <PostContentText
              key={paragraph.id}
              paragraph={paragraph as TextParagraphT}
            />
          ) : paragraph.type === 'personalMessage' ? (
            <PostContentPersonalMessage
              key={paragraph.id}
              paragraph={paragraph as PersonalMessageParagraphT}
              onPersonalMessageClick={onPersonalMessageClick}
            />
          ) : paragraph.type === 'image' ? (
            <PostContentImage
              key={paragraph.id}
              paragraph={paragraph as ImageParagraphT}
            />
          ) : paragraph.type === 'attachment' ? (
            <PostContentAttachment
              key={paragraph.id}
              paragraph={paragraph as AttachmentParagraphT}
            />
          ) : paragraph.type === 'youtube' ? (
            <PostContentYoutube
              key={paragraph.id}
              paragraph={paragraph as YoutubeParagraphT}
            />
          ) : paragraph.type === 'video' ? (
            <PostContentVideo
              key={paragraph.id}
              paragraph={paragraph as VideoParagraphT}
            />
          ) : paragraph.type === 'dummyImage' ? (
            <PostContentDummyImage
              key={paragraph.id}
              paragraph={paragraph as DummyImageParagraphT}
            />
          ) : null,
        )}
      </Stack>
    );
  },
);

export default PostContent;
